import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11 } from "styled-components";
import { takeFirst, stripHtmlTags } from "~/features/app/utils";
import { Media } from "~/features/ui/media";
import { Headline } from "~/features/ui/headline";
import { IconButton } from "~/features/ui/icon-button";
import ArrowTopRight from "~/public/icons/arrow-top-right.svg";
export type ExternalProductCardViewProps = {
  title?: string | null;
  description?: string | null;
  media?: Record<string, unknown> | Array<Record<string, unknown> | null | undefined> | null;
  url?: string | null;
};
export function ExternalProductCardView({
  title,
  description,
  media,
  url
}: ExternalProductCardViewProps) {
  const asset = takeFirst(media);
  const content = <_StyledDiv>
      {/* Image */}
      <_StyledDiv2>
        <_StyledDiv3>
          <IconButton as="div" icon={{
          component: ArrowTopRight,
          style: {
            "transitionProperty": "transform",
            "transitionDuration": "250ms",
            "transitionTimingFunction": "ease-in-out"
          }
        }} size="small" />
        </_StyledDiv3>
        <_StyledDiv4>
          <Media {...asset} imageProps={{
          fit: "cover",
          sizes: "lg:25vw"
        }} />
        </_StyledDiv4>
      </_StyledDiv2>

      {/* Content */}
      <_StyledDiv5>
        {title && <_StyledDiv6>
            <_StyledHeadline type="h3" text={title} />
            <_StyledSpan />
          </_StyledDiv6>}
        {description && <_StyledP>
            {stripHtmlTags(description)}
          </_StyledP>}
      </_StyledDiv5>
    </_StyledDiv>;
  if (url) {
    return <_StyledA href={url} target="_blank" rel="noopener noreferrer" className="group">
        {content}
      </_StyledA>;
  }
  return <_StyledDiv7 className="group">
      {content}
    </_StyledDiv7>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-lh6d2-0"
})({
  "display": "flex",
  "height": "100%",
  "flexDirection": "column"
});
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-lh6d2-1"
})({
  "position": "relative",
  "display": "flex",
  "height": "280px",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "4px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(227 227 240 / var(--tw-bg-opacity))",
  "@media (min-width: 1024px)": {
    "height": "330px"
  }
});
var _StyledDiv3 = _styled3("div").withConfig({
  componentId: "sc-sf-lh6d2-2"
})({
  "position": "absolute",
  "bottom": "0.4rem",
  "right": "0.4rem",
  "zIndex": "10",
  "display": "flex",
  "alignItems": "flex-end",
  "justifyContent": "flex-end",
  "gap": "0.4rem"
});
var _StyledDiv4 = _styled4("div").withConfig({
  componentId: "sc-sf-lh6d2-3"
})({
  "height": "100%",
  "width": "100%",
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out",
  ".group:hover &": {
    "--tw-scale-x": "1.05",
    "--tw-scale-y": "1.05",
    "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
  }
});
var _StyledDiv5 = _styled5("div").withConfig({
  componentId: "sc-sf-lh6d2-4"
})({
  "display": "flex",
  "flex": "1 1 0%",
  "flexDirection": "column",
  "paddingTop": "2.4rem",
  "@media (min-width: 1024px)": {
    "paddingTop": "4rem"
  }
});
var _StyledDiv6 = _styled6("div").withConfig({
  componentId: "sc-sf-lh6d2-5"
})({
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "gap": "1.6rem"
});
var _StyledHeadline = _styled7(Headline).withConfig({
  componentId: "sc-sf-lh6d2-6"
})({
  "fontSize": "2rem",
  "lineHeight": "1.3",
  "letterSpacing": "0.02rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "2.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.024rem",
    "fontWeight": "400"
  }
});
var _StyledSpan = _styled8("span").withConfig({
  componentId: "sc-sf-lh6d2-7"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "flexShrink": "0",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});
var _StyledP = _styled9("p").withConfig({
  componentId: "sc-sf-lh6d2-8"
})({
  "marginTop": "1.6rem",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "marginTop": "2.4rem",
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});
var _StyledA = _styled10("a").withConfig({
  componentId: "sc-sf-lh6d2-9"
})({
  "display": "block",
  "height": "100%",
  "cursor": "pointer",
  "transitionProperty": "transform",
  "transitionDuration": "250ms",
  "transitionTimingFunction": "ease-in-out"
});
var _StyledDiv7 = /*#__PURE__*/_styled11("div").withConfig({
  displayName: "external-product-card___StyledDiv7",
  componentId: "sc-pskpwc-0"
})({
  "height": "100%"
});